import { Dimensions } from 'react-native';

const { width, height } = Dimensions.get('window');

export const COIN_SIZE = 30;

export const DEFAULT_ENTRY_POINT = {
  x: width / 2,
  y: height / 2,
};
